import React, { Component, ElementType, ErrorInfo, ReactChild, ReactFragment, ReactNode, ReactPortal } from 'react';
import { StoreContext } from '../../store/store-provider';
import { observer } from 'mobx-react';
import Modal from '../shared/modal/modal';
import { ModalTypes } from '../../constans/modal.constants';
import './error-boundary.scss';

interface IProps {
  children: ElementType | ReactNode | ReactChild | ReactFragment | ReactPortal;
}

interface IState {
  hasError: boolean;
  isShow: boolean;
}

class ErrorBoundary extends Component<IProps, IState> {
  static contextType = StoreContext;

  constructor (props: IProps) {
    super(props);
    this.state = {
      hasError: false,
      isShow: true,
    };
  }

  refreshPage = (): void => {
    window.location.reload();
  };

  static getDerivedStateFromError (): {hasError: boolean} {
    return { hasError: true };
  }

  componentDidCatch (error: Error, errorInfo: ErrorInfo) {
    this.context.errorBoundaryStore.setErrorMessage({});
  }

  render (): JSX.Element {
    return (
      <>
        {this.state.hasError || this.context.errorBoundaryStore.errorMessage
          ? this.state.isShow && (
            <Modal
              cancelAction={this.refreshPage}
              doneAction={this.refreshPage}
              modalType={ModalTypes.ERROR}
              bodyText={this.context.errorBoundaryStore.errorMessage}
            />)
          : null}
        { this.props.children }
      </>
    );
  }
}

export default observer(ErrorBoundary);
